<template>
    <div>

        <b-row>

            <b-col md="6" v-for="(device, idx_d) in devices" :key="idx_d">

                <div class="proj-toolbox-area device">
                    <div class="device-info">
                        <div class="device-name">
                            <i :class="$tools.style.classIcon(device.type, 'block-title')"></i>{{ device.nickname }}
                            <div class="block-text device-hashid">{{ device.hashid }}</div>
                            <div v-if="user_admin" class="block-text device-deviceid">( Device ID = {{ device.deviceid }} )</div>
                        </div>
                        <div v-if="device.description" class="text-muted">{{ device.description }}</div>

                    </div>
                    <div>
                        <div class="device-sensor">
                            <!-- <b-form-group> -->
                                <b-form-checkbox-group v-model="selected_params" >
                                    <b-form-checkbox v-for="(param, idx_pa) in showDeviceSensorItems(device)" :key="idx_pa"
                                                     :value="device.hashid + ' ' + param">

                                                <div class="device-sensor-blocks">
                                                    {{ $t('sensor.' + param) }}
                                                    <div class="device-unit" v-html="$t('sensor.u_' + param)"></div>
                                                </div>

                                    </b-form-checkbox>
                                    <b-form-checkbox v-for="(param_add, idx_pa_add) in devices_additional_keys[ device.hashid ]" :key="'additional_' + idx_pa_add"
                                                     :value="device.hashid + ' ' + param_add">

                                                <div class="device-sensor-blocks">
                                                    {{ $t('sensor.' + param_add) }}
                                                    <div class="device-unit" v-html="$t('sensor.u_' + param_add)"></div>
                                                </div>

                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            <!-- </b-form-group> -->
                        </div>
                    </div>
                    <b-alert v-if="user_admin && device.note" variant="secondary" show >Note：{{ device.note }}</b-alert>
                </div>

            </b-col>

        </b-row>




        <div class="proj-toolbox-area">
            <h4>
                {{ $t('menu.selected') }} {{ $t('menu.sensor_parameter') }}
                <div class="block-text text-muted">( {{ $t('menu.comparison') }} {{ $t('menu.limit') }} = {{ comparison_max }} )</div>
                <!-- <code>{{ valid_selection }}</code> -->
            </h4>
            <div>
                <div class="block-text" v-for="(selected, idx_s) in valid_selection" :key="idx_s">
                    <b-badge variant="success" class="badge-normal badge-selected">
                        {{ params_mappings[selected].device.hashid }} -
                        {{ params_mappings[selected].device.nickname }} -
                        {{ $t('sensor.' + params_mappings[selected].param) }}
                        <span v-if="user_admin">({{ params_mappings[selected].param }}) </span>
                        <span v-html="$t('sensor.u_' + params_mappings[selected].param)"></span>
                    </b-badge>
                </div>
            </div>

            <div class="text-center">
                <b-button variant="secondary" class="px-4 btn-upload" @click="selected_params = []" >
                    {{ $t('menu.deselect') }}
                </b-button>


                <!-- <div class="text-center"> -->
                    <!-- <h5>歷史資料範圍選擇 (非自動更新，10 分鐘一筆)</h5> -->

                    <DatePickerTool :timezone="timezone" @date-range="dateRange = $event" ></DatePickerTool>

                    <!-- Default API -->
                    <b-button id="button-show" class="btn btn-success px-4 btn-upload"
                            @click="setQueryType()"
                            :disabled="loading_showInfo || checkDisabled" >
                        <i class="fa fa-search block-text"></i>{{ $t('menu.comparison') }}
                    </b-button>

                    <!-- Admin API -->
                    <b-button id="button-show" class="btn btn-danger px-4 btn-upload btn-red"
                            v-if="user_admin"
                            @click="setQueryType('admin')"
                            :disabled="loading_showInfo || checkDisabled" >
                        <i class="fa fa-search block-text"></i>Admin {{ $t('menu.comparison') }}
                    </b-button>
                <!-- </div> -->

            </div>
        </div>

        <!-- 阿龜資料讀取畫面 -->
        <div v-if="loading_showInfo">
            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
        </div>

        <div v-if="comparison_data">
            <h3>{{ $t('menu.mix_chart') }}</h3>

            <b-row align-v="center" align-h="center">
                <b-col md="11">
                    <MixChartMultipleParams v-if="comparison_data.time" :chartID="'device-chart-compare'"
                                        :info_type="'report'"
                                        :time="comparison_data.time"
                                        :dataList="comparison_data"
                                        :dataDisplaySettings="chart_display_setting"
                                        :chartTitle="'Compare Chart'"
                                        :dataZoom="true"
                                        :showToolbox="true"
                                        :showYAxisAlignInfo="true"
                                        :xAxisFormat="'MM/DD HH:mm'"
                                        :xAxisName="'date'" ></MixChartMultipleParams>
                </b-col>
                <!-- <b-col md="5">
                    <b-alert show variant="info">
                        <h4 class=""><i :class="$tools.style.classIcon(device.type, 'block-title')"></i>{{ device.hashid }} {{ device.nickname }}</h4>
                        <div>
                            <div class="block-text">{{ $t('sensor.rainfalls') }} Sum：</div>
                            {{ device.water.rainfalls_sum }} {{ $t('sensor.u_rainfalls') }}
                        </div>
                    </b-alert>
                </b-col> -->
            </b-row>
            <ChartTooltip :defaultOpen="true"></ChartTooltip>
        </div>


    </div>
</template>

<script>
import { mapState } from 'vuex'
import ecTools from '@/echarts/echarts-tools'
import AgriLoading from '@/views/components/AgriLoading'
import ChartTooltip from '@/views/components/Tooltip_Charts'
import DatePickerTool from '@/views/components/DatePickerTool'
import MixChartMultipleParams from '@/views/echarts/MixChart_MultipleParams'


export default {
    props: {
        devices: {
            type: Array,
            required: true,
        },
        project_id: {
            type: [Number,String],
        },
        project_role: {
            type: String,
            default: 'member',
        },
        comparison_max: {
            type: Number,
            default: 6,
        },
        timezone: {
            type: String,
            default: 'Asia/Taipei',
        },
    },
    components: {
        AgriLoading,
        ChartTooltip,
        DatePickerTool,
        MixChartMultipleParams,
    },
    data () {
        return {
            loading_showInfo: false,
            selected_params: [],
            params_mappings: {},
            devices_additional_keys: {},

            dateRange: undefined,

            chart_display_setting: [],
            comparison_data: undefined,
        }
    },
    mounted ()
    {
        this.createParamsMap();
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'project_timezone': state => state.project.project_timezone,
        }),


        valid_selection ()
        {
            // 限定最多比較四個參數
            if ( this.selected_params.length > this.comparison_max )
            {
                this.selected_params = this.selected_params.slice( 0, this.comparison_max )
            }
            return this.selected_params;
        },

        // Download Button Check State
        checkDisabled () {

            if (this.selected_params.length == 0)        return true;
            if (this.dateRange == undefined)             return true;
            if (this.dateRange.start_time == undefined)  return true;
            if (this.dateRange.end_time == undefined)    return true;

            return false;
        },
    },
    watch: {

        devices (val, oldVal)
        {
            this.createParamsMap();
        },
    },
    methods: {

        createParamsMap ()
        {
            this.params_mappings = {};
            this.devices.forEach( _device => {

                this.devices_additional_keys[ _device.hashid ] = []

                if ( _device.sensor_params )
                {
                    _device.sensor_params.forEach( _param => {

                        let _key = _device.hashid + ' ' + _param
                        this.params_mappings[ _key ] = {
                            device: _device,
                            param: _param,
                        }

                        // 電壓 V 轉電量 %
                        if ( _param == 'voltage' )
                        {
                            let _additional_key = _device.hashid + ' ' + 'voltage_to_battery_percentage'
                            this.params_mappings[ _additional_key ] = {
                                device: _device,
                                param: 'voltage_to_battery_percentage',
                            }

                            this.devices_additional_keys[ _device.hashid ].push( 'voltage_to_battery_percentage' )
                        }
                    })

                }
            })
        },

        showDeviceSensorItems (device)
        {
            if ( device.sensor_params )
            {
                // Admin、Beehive 顯示所有感測器參數
                if ( this.user_admin == true ) return device.sensor_params
                if ( this.$tools.service.check_ShowUI_byRole(this.project_role, 'sensor_params') == true ) return device.sensor_params

                return device.visualization
            }
            else return []
        },


        setQueryType (queryType = 'default')
        {
            this.getData_History( queryType );
        },

        /**
         * arrange_DevicesToCall 整理要呼叫那些裝置和參數，相同裝置的參數集結在一起
         */
        arrange_DevicesToCall ()
        {
            let _list_devices_to_call = {}
            this.valid_selection.forEach( selected_key => {

                let _selected_info   = this.params_mappings[ selected_key ]
                let _selected_hashid = this.params_mappings[ selected_key ].device.hashid

                if ( _list_devices_to_call[ _selected_hashid ] == undefined )
                {
                    _list_devices_to_call[ _selected_hashid ] = {
                        hashid: _selected_hashid,
                        device: _selected_info.device,
                        param: [],
                    }
                }
                _list_devices_to_call[ _selected_hashid ].param.push( _selected_info.param ) // 要比較的參數

                if ( _selected_info.param == 'voltage_to_battery_percentage' )
                {
                    if ( _list_devices_to_call[ _selected_hashid ].param.find( _find_Param => _find_Param === 'voltage' ) == undefined )
                    {
                        _list_devices_to_call[ _selected_hashid ].param.push('voltage')
                    }
                }
            })
            return Object.values( _list_devices_to_call )
        },

        getData_History (queryType)
        {
            this.comparison_data = undefined
            this.loading_showInfo = true

            let _start_time = this.$tools.date.dataTimeZone_to_UTC( this.dateRange.start_time, this.timezone );
            let _end_time = this.$tools.date.dataTimeZone_to_UTC( this.dateRange.end_time, this.timezone );
            let _list_devices_to_call = this.arrange_DevicesToCall();
            let _list_Promise = []

            _list_devices_to_call.forEach( _device => {
                let querySettings = {
                    deviceID:       _device.hashid,
                    timezone:       this.timezone,
                    start_time:     _start_time,
                    end_time:       _end_time,
                }
                // admin API
                if ( queryType == 'admin' )
                {
                    querySettings.url = this.$config.getAPI_URL('Admin_Device_History', { deviceID: _device.hashid, start_time: _start_time, end_time: _end_time }) + '&compare=true'
                    _list_Promise.push( this.$store.dispatch('device/getDeviceData_Admin', querySettings) )  // 排進 promise 等待執行列
                }
                // users API
                else
                {
                    querySettings.url = this.$config.getAPI_URL('Get_Project_Device_History', { projectID: this.project_id, deviceID: _device.hashid })
                    querySettings.url += `start_time=${ _start_time }&end_time=${ _end_time }&compare=true`
                    querySettings.url += `&params=${ _device.param.join(',') }`
                    _list_Promise.push( this.$store.dispatch('device/getProjectDeviceData_History', querySettings) )  // 排進 promise 等待執行列
                }

            })

            // 使用 promise.all 執行所有等待呼叫的 API，並確保每支 API 都回傳 resolve 才會進入 then
            Promise.all( _list_Promise )
            .then( res => {
                this.loading_showInfo = false

                /// 取得 API 回傳的資料後，依照呼叫順序將裝置 hashid 與資料綁定
                let _data_of_device = {}
                for (let i=0; i<res.length; i++)
                {
                    _data_of_device[ _list_devices_to_call[i].hashid ] = res[i]
                    // 格式：{ 'DA0000: { 'time': [], 'soil_temperature': [], 'voltage': [] } }

                    let __deviceData = _data_of_device[ _list_devices_to_call[i].hashid ]
                    if ( __deviceData.voltage != undefined )
                    {
                        __deviceData.voltage_to_battery_percentage = this.$tools.ui.getVoltageToPercentage(__deviceData.voltage);
                    }
                }
                // console.log( _data_of_device )

                /// 將資料列轉換成 MixChart_MultipleParams 需要的格式
                this.comparison_data = { time: undefined }
                this.valid_selection.forEach( selected_key => {
                    let _map_param = this.params_mappings[ selected_key ]
                    if ( _data_of_device[ _map_param.device.hashid ] )
                    {
                        this.comparison_data[ selected_key ] = _data_of_device[ _map_param.device.hashid ][ _map_param.param ]
                        this.comparison_data['time'] = _data_of_device[ _map_param.device.hashid ]['time']
                        // 格式：{ 'DA0000_soil_temperature: [], 'DA0000_voltage': [] }
                    }
                })

                /// 設定 MixChart_MultipleParams 的每個資料的基本資訊
                this.getChartDisplaySetting()
                // console.log( this.comparison_data )

            })
            .catch( err => {
                this.loading_showInfo = false
            })

            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'read',
                detail: {
                    page: 'comparison',
                    action: 'enter comparison',
                    querySettings: {
                        'project ID':     this.project_id,
                        'project role':   this.project_role,
                        'timezone':       this.timezone,
                        'start time':     _start_time,
                        'end time':       _end_time,
                        'sensor params':  _list_devices_to_call.map( _device => {
                            return `${ _device.device.nickname } [${ _device.hashid }] (${ _device.hashid[0] }${ _device.hashid[1] }-${ _device.device.deviceid }): ${ _device.param.join(',') }`
                        }).join(`； `),
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },

        /**
         * 取得多參數圖表要用的資料設定
         */
        getChartDisplaySetting ()
        {
            let _displayData = []

            this.valid_selection.forEach( selected_key => {
                let _map_param = this.params_mappings[ selected_key ]

                _displayData.push( ecTools.sensorMapping( selected_key, _map_param.device, _map_param.param, false ) )
            })
            // console.log( _displayData )

            this.chart_display_setting = _displayData
        },

    }
}
</script>

<style lang="scss" scoped>


</style>
